module.exports = __webpack_public_path__ + "static/media/tyrah-odoms.811e1f93.md";